import React, { forwardRef } from "react"
import Button from "./Button/Button"
import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import Icon from "../Icons/Icon/Icon"
import { TIconKey } from "../Icons/Icon/Interfaces"
import { TSide } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import concatWithSpaces from "components/ProjectNonSpecificComponents/Functions/concatWithSpaces"

interface Props extends React.ComponentProps<"button"> {
	iconKey?: TIconKey
	iconWidth?: string | number
	iconHeight?: string | number
	iconAndTextColor?: string
	iconSide?: TSide
	semiTransparent?: boolean
	borderless?: boolean
	children?: React.ReactNode
	preventWrap?: boolean
}

const MediumButton = forwardRef<HTMLButtonElement, Props>(
	(
		{
			iconKey,
			iconWidth,
			iconHeight,
			iconAndTextColor,
			iconSide = "left",
			onClick,
			style,
			children,
			preventWrap,
			...props
		},
		ref
	) => {
		const { isMobile } = useScreenType()

		const IconContainer = iconKey ? (
			<HyperDiv direction="row">
				{iconSide == "right" && <Whitespace h x=".625" />}
				<HyperDiv className="">
					<Icon
						iconKey={iconKey}
						width={iconWidth ?? 17}
						height={iconHeight ?? 17}
						iconColor={iconAndTextColor}
					/>
				</HyperDiv>
				{iconSide == "left" && <Whitespace h x=".625" />}
			</HyperDiv>
		) : null

		return (
			<Button
				{...props}
				style={{
					height: isMobile ? 42 : 55,
					minWidth: isMobile ? 42 : 55,
					padding: isMobile ? 4 : "0 16px",
					fontSize: 16,
					fontWeight: 600,
					cursor: onClick ? "pointer" : "",
					...style,
				}}
				onClick={onClick}
				ref={ref}
			>
				<HyperDiv direction="row" centered>
					{iconSide == "left" && IconContainer}
					<HyperDiv
						style={{
							color: iconAndTextColor,
						}}
						className={concatWithSpaces(
							"items-center",
							preventWrap ? "block whitespace-nowrap overflow-ellipsis overflow-hidden" : "flex"
						)}
					>
						{children}
					</HyperDiv>
					{iconSide == "right" && IconContainer}
				</HyperDiv>
			</Button>
		)
	}
)

export default MediumButton
